import React, { Component } from "react"
import Slider from "react-slick"
import styled from "styled-components"
import { motion } from "framer-motion"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./parentsSlider.css"

import img1 from "../../images/boy-learning.jpg"
import img2 from "../../images/learn-at-home.jpg"
import gif from "./video-demo.gif"

const photos2 = [
  {
    title: "Learn the basics of programming",
    description:
      "We begin by introducing students to the fundamental concepts that are used in every programming language. Concepts such as loops, functions, conditionals and more!",
  },
  {
    title: "Constant collaboration",
    description:
      "Kids meet with other like minded students, and together they’re able to solve problems using code. School encourages students to speak their mind, ask questions and solve problems. We do the same!",
  },
  {
    title: "Creativity is the limit",
    description:
      "Whatever your passion is, whether it is drawing, doing math and sciences, you can inject that into your code. Let your creativity run wild. After all, creativity is intelligence having fun :)",
  },
]

const photos = [
  {
    title: "Creating animations",
    description:
      "Through coding fun animations and projects, kids understand the fundamentals of the programming concepts.",
    url: gif,
  },
  {
    title: "Inspiring collaboration",
    description:
      "Kids create projects and take part in fun & friendly activities and competitions with other campers. Expect to stay in the loop as projects are easily shareable!",
    url: img2,
  },
  {
    title: "Rewards",
    description:
      "In our friendly competitions, students have the chance to take home fun prizes by showcasing what they’ve learned and created.",
    url: img1,
  },
]

const companyData = [
  {
    title: "Virtual camps",
    description:
      "Our camps are filled with knowledge demonstrated in an extremely fun way. Students create animations, stories, and projects that excite them. All while learning how to code and build things.",
    url: gif,
  },
  {
    title: "Bring your employees’ kids together",
    description:
      "Foster a culture of belonging and learning, not just for your employees but for their kids as well! Our camps are collaborative and inspire students to work alongside each other to solve problems.",
    url: img2,
  },
  {
    title: "Create the next generation of talent",
    description:
      "Our mission is to get students into programming as early as possible, so that they can lead our next generation of technology.",
    url: img1,
  },
]


function SampleNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <FontAwesomeIcon
      className={className}
      style={style}
      onClick={onClick}
      icon={faAngleRight}
      size="xs"
      height="12px"
      width="12px"
    />
  )
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <FontAwesomeIcon
      className={className}
      style={style}
      onClick={onClick}
      icon={faAngleLeft}
      size="xs"
    />
  )
}

export default class extends Component {
  constructor(props) {
    super(props)
    this.getContent = this.getContent.bind(this)
  }

  getContent = settings => {
    const { company } = this.props
    if (company) {
      return (
        <>
          <h2 className="par-slider-header">{"Why Codehall"}</h2>
          <StyledSlideshow>
            <div
              className="par-slider-container"
              id={this.props.noPic ? "par-slider-dots" : ""}
              style={this.props.noPic ? { maxWidth: "600px", maxHeight: '800px' } : {maxHeight: '800px'}}
            >
              <Slider {...settings} style={{backgroundColor: '#eef6fd'}}>
                {companyData.map((photo, index) => {
                  return (
                    <>
                      <div key={index} className="par-slider-content">
                        <div className="par-slider-image">
                          <img src={photo.url} alt={`${photo.title}`}></img>
                        </div>
                        <div className="par-slider-body">
                          <div
                            className="par-slider-body-inner"
                            style={{ margin: "auto" }}
                          >
                            <h4 className="par-slider-title">{photo.title}</h4>
                            <p className="par-slider-subtitle">
                              {photo.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  )
                })}
              </Slider>
            </div>
          </StyledSlideshow>
        </>
      )
    } else {
      return (
        <>
          <h2 className="par-slider-header">
            {this.props.noPic
              ? "Building a Strong Coding Foundation & More"
              : "Why Kids Love Codehall"}
          </h2>
          <StyledSlideshow>
            <div
              className="par-slider-container"
              id={this.props.noPic ? "par-slider-dots" : ""}
              style={this.props.noPic ? { maxWidth: "600px" } : {}}
            >
              <Slider {...settings} style={{backgroundColor: '#eef6fd'}}>
                {this.props.noPic
                  ? photos2.map((photo, index) => {
                      return (
                        <div
                          key={index}
                          className="par-slider-content"
                          style={{ minHeight: "500px" }}
                        >
                          <div
                            className="par-slider-body parents"
                            style={{ width: "100%" }}
                          >
                            <div
                              className="par-slider-body-inner"
                              style={{ width: "100%", margin: "auto" }}
                            >
                              <h4 className="par-slider-title">
                                {photo.title}
                              </h4>
                              <p className="par-slider-subtitle">
                                {photo.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  : photos.map((photo, index) => {
                      return (
                        <>
                          <div key={index} className="par-slider-content">
                            <div className="par-slider-image">
                              <img src={photo.url} alt={`${photo.title}`}></img>
                            </div>
                            <div className="par-slider-body">
                              <div
                                className="par-slider-body-inner"
                                style={{ margin: "auto" }}
                              >
                                <h4 className="par-slider-title">
                                  {photo.title}
                                </h4>
                                <p className="par-slider-subtitle">
                                  {photo.description}
                                </p>
                              </div>
                            </div>
                          </div>
                        </>
                      )
                    })}
              </Slider>
            </div>
          </StyledSlideshow>
        </>
      )
    }
  }

  render() {
    const settings = {
      dots: true,
      dotsClass: "slick-dots",
      pauseOnHover: true,
      infinite: true,

      speed: 500,
      slidesToShow: 1,
      arrows: true,
      slidesToScroll: 1,
      className: "slideshow",
      autoplay: true,
      autoplaySpeed: 5000,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    }
    return (
      <motion.div
        initial="hidden"
        animate="visible"
        variants={{
          visible: { opacity: 1, y: 0 },
          hidden: { opacity: 0, y: 20 },
        }}
        transition={{ ease: "easeOut", duration: 0.8, delay: 1.5 }}
      >
        {this.getContent(settings)}
      </motion.div>
    )
  }
}

const StyledSlideshow = styled.div`
  margin: 0 20px;
  margin-bottom: 60px;
  display: flex;
  align-content: center;
  justify-content: center;

  #par-slider-dots ul.slick-dots {
    display: flex;
    left: 33%;
  }

  @media (max-width: 1135px) {
    .par-slider-image {
      display: none;
    }

    .par-slider-content .par-slider-body {
      height: 100%;
      width: 100%;
    }

    .par-slider-container ul.slick-dots {
      width: 100%;
      left: 50%;
      transform: translateX(-50%);
      padding: 0;
      text-align: center;
    }

    #par-slider-dots ul.slick-dots {
      display: flex !important;
      align-items: center;
      justify-content: center;
      left: 50%;
      padding: 0;
    }
  }

  @media (max-width: 748px) {
    .par-slider-title {
      font-size: 2rem;
      line-height: 2.2rem;
    }

    #par-slider-dots ul.slick-dots {
      left: 50%;
    }

    .par-slider-minititle {
      display: none;
    }

    .par-slider-image {
      display: none;
    }

    .par-slider-body-inner {
      margin-top: 32px;
      padding: 12px;
    }

    .par-slider-content .slider-body {
      padding: 16px;
      text-align: center;
    }

    .slider-content .slider-subtitle {
      max-width: 100%;
    }

    .par-slider-container ul.slick-dots {
      width: 100%;
      transform: translateX(-50%);
      padding: 0;
      text-align: center;
      display: flex;
      align-items: center;
    }

    .par-slider-body {
      height: 500px;
      padding: 32px 32px 132px 32px !important;
    }
  }
`
